const globImage = import.meta.glob('~/assets/(image|svg)/**', {
  eager: true
})

export const useDynamicImage = imageName => globImage[`/assets/${imageName}`].default
